import { FC } from 'react';

import { PLAN_CARD_TEST_ID } from '../constants';
import { PlanCardModel } from '../model';
import { CardBadge } from '../PlanCard.styles';

export const Badge: FC<PlanCardModel.BadgeProps & PlanCardModel.NegativeProp> = ({ text, variant, isNegative }) => {
    if (!text) {
        return null;
    }

    return (
        <CardBadge aria-hidden="true" $negative={isNegative} $variant={variant} data-test={PLAN_CARD_TEST_ID.BADGE}>
            {text}
        </CardBadge>
    );
};
